import { useRef, useState, type Ref } from "react";
import { useIch } from "../api/abfragen";
import { RueckmeldungBlatt } from "../seiten/RueckmeldungBlatt";
import { RM } from "../seiten/rueckmeldung/satzquelle";
import { Chip } from "./Badge";

/** W82 Beta-W (D-637, F4 = A): das kleine Zeichen „Beta“, nur in Beta-Haushalten (`ich.beta`). Ein eigener Knopf, nie im
 *  Profilknopf (kein Knopf im Knopf); Trefferfläche mindestens 44 x 44, darin der Akzent-Chip ohne Symbol. Ein Tipp öffnet das
 *  Blatt „Rückmeldung geben“ direkt, der Fokus kommt danach hierher zurück (`BetaLeiste`). W82 Beta-W2 (D-701, HB2): es steht
 *  unten in Seitenleiste und Rail, nicht mehr neben dem Profil. */
export function BetaZeichen({ ref, onOeffnen, className = "" }: { onOeffnen: () => void; ref?: Ref<HTMLButtonElement>; className?: string }) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={RM["beta.zeichen.name"]}
      aria-haspopup="dialog"
      data-testid="beta-zeichen"
      onClick={onOeffnen}
      // W82 Web-5h-N2 a8 (H5): Schwebezustand wie der Profilknopf, Druck nach DESIGN „Drücken“ (rest.css, Apple-Soll); W82 Web-6a
      // (WN-17): Farbe und Hover-Abfrage stehen dort wie beim Profilknopf, nicht als Tailwind-Hover (klebte bei Touch)
      className={`beta-zeichen grid min-h-(--touch) min-w-(--touch) shrink-0 place-items-center rounded-pill ${className}`}
    >
      <Chip zustand="akzent" icon={null}>
        {RM["beta.zeichen"]}
      </Chip>
    </button>
  );
}

/** W82 Beta-W2 (D-701, HB2): das Zeichen als letztes Element der Leiste, unten unter „Post per Mail“ (ist die Leiste höher als
 *  der Bildschirm, nach „Post per Mail“ im Rollbereich). Seitenleiste: links bündig mit den Symbolen der Zeilen; Rail: mittig.
 *  Eigenes Blatt (dasselbe `RueckmeldungBlatt`, kein neues `Sheet`), der Fokus kommt auf das Zeichen zurück. */
export function BetaLeiste(props: { form: "rail" | "seitenleiste" }) {
  const { data: ich } = useIch();
  const zeichen = useRef<HTMLButtonElement>(null);
  const [offen, setOffen] = useState(false);
  if (ich?.beta !== true) return null;
  return (
    <div className={`beta-unten mt-auto flex shrink-0 flex-col pt-3 ${props.form === "rail" ? "items-center" : "items-start"}`} data-testid="beta-unten">
      <BetaZeichen ref={zeichen} onOeffnen={() => setOffen(true)} className={props.form === "rail" ? "" : "ml-3"} />
      <RueckmeldungBlatt offen={offen} modus="rueckmeldung" onSchliessen={() => setOffen(false)} fokusNachher={() => zeichen.current} />
    </div>
  );
}
